import { Component, OnInit } from '@angular/core';
import { DatastoreService } from '../../services/datastore.service';
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';

@Component({
  selector: 'app-permits-submitted',
  templateUrl: './permits-submitted.component.html',
  styleUrls: ['./permits-submitted.component.scss'],
})
export class PermitsSubmittedComponent implements OnInit {
  parentDepartment: any;
  pageTitle: string;
  guidanceMsg: any;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;

  constructor(
    public datastoreService: DatastoreService,
    private router: Router
  ) {}

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'instant' });
    this.parentDepartment = this.datastoreService.parentDepartment;
    console.log(this.parentDepartment);

    if (this.parentDepartment) {
      console.log(this.parentDepartment.extra);
      // Set the title on the login page to the title from the business question
      this.parentDepartment.extra?.hasOwnProperty(
        'permits_submitted_page_title'
      )
        ? (this.pageTitle =
            this.parentDepartment.extra.permits_submitted_page_title)
        : (this.pageTitle = 'permits_submitted_page_title title not set');

      this.parentDepartment.extra?.hasOwnProperty(
        'permits_submitted_page_guidance_text'
      )
        ? (this.guidanceMsg =
            this.parentDepartment.extra.permits_submitted_page_guidance_text)
        : (this.guidanceMsg = 'permits_submitted_page_guidance_text not set');
    } else {
      this.restartJourney();
    }
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  goHome() {
    window.location.href =
      'https://www.lincolnshire.gov.uk/recycling-waste';
  }
}
